export const notificationsStyles = ({ isScreenLowerThan1024 = false, notification = {} } = {}) => ({
    iconButton: {
        position: 'relative',
        padding: '8px',
        marginTop: '15px',
        color: (theme) => (theme.palette.mode === 'dark' ? '#9EA3AE' : '#6C727F'),
        '&:hover': {
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
        },
    },

    badge: {
        '& .MuiBadge-badge': {
            top: 2,
            right: 2,
            minWidth: 16,
            height: 16,
            padding: '0 4px',
            fontSize: '0.7rem',
            backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#F87171' : '#D32F2F'),
            color: '#fff',
        },
    },

    notificationItem: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '12px',
        marginBottom: '8px',
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: (theme) =>
            notification.is_read
                ? 'transparent'
                : theme.palette.mode === 'dark'
                ? '#2A313D'
                : 'rgba(0, 0, 0, 0.04)',
        '&:hover': {
            backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? '#394150' : 'rgba(0, 0, 0, 0.08)',
        },
    },

    notificationDesc: {
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        marginBottom: '4px',
        color: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.65)' : '#6C727F'),
        fontSize: '14px',
    },

    unreadDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#F87171' : '#D32F2F'),
        marginLeft: '8px',
        marginTop: '4px',
        flexShrink: 0,
    },

    notificationsList: {
        maxHeight: '400px',
        overflowY: 'auto',
        paddingRight: '8px',
    },

    menuPaper: {
        width: '400px',
        maxHeight: '600px',
        mt: 1.5,
        borderRadius: '12px',
        boxShadow: (theme) =>
            theme.palette.mode === 'dark'
                ? '0 10px 20px rgba(0, 0, 0, 0.7)'
                : '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A313D' : '#fff'),
        '& .MuiList-root': {
            py: 0,
        },
    },

    menuBox: {
        p: 2.5,
        backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#2A313D' : '#fff'),
    },
});
